<template lang="pug">
v-autocomplete(
  :items="items"
  v-model="item"
  :get-label="getLabel"
  :component-item="itemTemplate"
  @update-items="updateItems"
  input-class="form-input"
)
</template>

<script>
import ItemTemplate from './ItemTemplate.vue'
import plansServices from '@/services/plans'

export default {
  data() {
    return {
      items: [],
      item: null,
      itemTemplate: ItemTemplate,
    }
  },
  props: {
    value: { type: Number },
  },
  watch: {
    item(v) {
      if (v) this.model = v.id
      else this.model = null
    },
  },
  computed: {
    model: {
      get() {
        return this.item ? this.item.id : null
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    getLabel(item) {
      if (!item) return ''
      return item.title
    },
    async updateItems(title = '') {
      try {
        const { data } = await plansServices.list({
          limit: 100,
          q: { isManualPayment: true, status: true, title },
        })
        this.items = data.rows
      } catch (e) {
        this.$toaster.error('Erro ao carregar lista de planos')
      }
    },
  },
  created() {
    this.updateItems()
  },
}
</script>

<style lang="stylus">
.v-autocomplete
  z-index 99999999
  .v-autocomplete-input-group
    .v-autocomplete-input
    &.v-autocomplete-selected
      .v-autocomplete-input
        color green
        background-color #f2fff2
  .v-autocomplete-list
    width 100%
    text-align left
    border none
    border-top none
    max-height 250px
    overflow-y auto
    border-bottom 1px solid #157977
    .v-autocomplete-list-item
      font-size 14px
      cursor pointer
      background-color #fff
      padding 10px
      border-bottom 1px solid #157977
      border-left 1px solid #157977
      border-right 1px solid #157977
      &:last-child
        border-bottom none
      &:hover
        background-color #eee
      abbr
        opacity 0.8
        font-size 0.8em
        display block
        font-family sans-serif
</style>
